"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OAuth2 = (function () {
    function OAuth2(clientId, redirectUri, callBack) {
        this.url_backend = "https://auth2server.3cad.it/Oauth2/1.0.0/codegrant/authorize?response_type=code";
        this.client_id = clientId;
        this.redirect_uri = redirectUri;
        this.call_back = callBack;
        window.DauAuth = this;
    }
    OAuth2.prototype.launchAuthWindow = function () {
        var path = this.buildHrefPath();
        this.child_window = this.PopupCenter(path, "OAuth2 Dau Form", 500, 700);
        return true;
    };
    OAuth2.prototype.PopupCenter = function (url, title, w, h) {
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var systemZoom = width / window.screen.availWidth;
        var left = (width - w) / 2 / systemZoom + dualScreenLeft;
        var top = (height - h) / 2 / systemZoom + dualScreenTop;
        return window.open(url, title, 'scrollbars=yes, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);
    };
    OAuth2.prototype.buildHrefPath = function () {
        return this.url_backend + "&client_id=" + this.client_id + "&redirect_uri=" + this.redirect_uri;
    };
    OAuth2.prototype.onLoginSuccess = function (response) {
        this.child_window.close();
        this.call_back(response);
    };
    OAuth2.prototype.checkIfChildWindow = function () {
        if (window.opener != null && window.opener.DauAuth != null) {
            var hash = window.location.search.substr(1);
            var params = hash.split('&');
            var auth_code = params[0].split('=')[1];
            window.opener.DauAuth.onLoginSuccess(auth_code);
        }
    };
    return OAuth2;
}());
exports.OAuth2 = OAuth2;
//# sourceMappingURL=OAuth2.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/dau-auth-library/dist/OAuthLib/OAuth2.js
// module id = 1437
// module chunks = 142